import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';
import Card from '@/components/common/Card';
import Button from '@/components/common/Button';

const REASON_KEY_MAP: Record<string, string> = {
  payment_failed: 'payment.fail.reasons.paymentFailed',
  payment_not_verified: 'payment.fail.reasons.paymentNotVerified',
  server_error: 'payment.fail.reasons.serverError',
};

export default function PaymentCancelPage() {
  const { t } = useTranslation('recruiter');
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason');

  const reasonMessageKey = reason && REASON_KEY_MAP[reason]
    ? REASON_KEY_MAP[reason]
    : 'payment.fail.reasons.unknown';

  return (
    <div className="container-custom py-12">
      <div className="max-w-2xl mx-auto">
        <Card className="text-center">
          <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-red-600" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-3">{t('payment.fail.title')}</h1>
          <p className="text-gray-600 mb-4">
            {t('payment.fail.message')}
          </p>

          {reason && (
            <div className="mb-8 p-4 bg-red-50 rounded-lg text-sm text-red-700">
              <p>{t(reasonMessageKey)}</p>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/recruiter/packs">
              <Button variant="primary" className="flex items-center gap-2">
                <RefreshCw className="w-4 h-4" />
                {t('payment.fail.tryAgain')}
              </Button>
            </Link>
            <Link to="/recruiter/dashboard">
              <Button variant="secondary" className="flex items-center gap-2">
                <ArrowLeft className="w-4 h-4" />
                {t('payment.fail.backToDashboard')}
              </Button>
            </Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
